import Controller from '../abstracts/Controller';
import 'scss-templates/t-page-gone.scss';

export default class PageGoneController extends Controller {
  static get COMPONENTS() {
    return [
      'RecommendationEngineComponent'
    ];
  }
}
